import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ChallengeInlineDialogData } from '../challenge-inline-dialog/challenge-inline-dialog.component';

@Component({
  selector: 'app-qr-reject-dialog',
  templateUrl: './qr-reject-dialog.component.html',
  styleUrls: ['./qr-reject-dialog.component.scss']
})
export class QrRejectDialogComponent implements OnInit {

  errorMsg = '';
  constructor(@Inject(MAT_DIALOG_DATA) public dialogData: ChallengeInlineDialogData, 
      private dialogRef: MatDialogRef<QrRejectDialogComponent>
    ) {}

  ngOnInit(): void {
  }

  onRenew() {
    this.dialogRef.close('renew');
  }

}
